import defaultCoreConfiguration from './../config';
import appConfiguration from './../custom/config';

class Configuration {

    /**
     * @type Object
     * @private
     */
    _configuration;

    constructor() {

        this._configuration = Object.assign(defaultCoreConfiguration, appConfiguration);

    }

    getConfig() {
        return this._configuration;
    }

    isOverrideCoreModuleWithCustom(coreModule) {
        if (this._configuration.hasOwnProperty('overrideCoreModules')) {
            const overrideCoreModules = this._configuration.isOverrideCoreModules;
            if (Array.isArray(overrideCoreModules)) {
                if (overrideCoreModules.find(coreModule)) {
                    return true;
                }
            }
        }

        return false;
    }

}

const configuration = new Configuration();

export default configuration;